import { useTheme } from "@app/store/themeStore";
import { Chip, type ChipProps } from "@design-system/Inputs/Chip";
import { type FC, type Ref } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "./i18n";

export const SubthemeTag: FC<
    ChipProps & {
        themeId: string;
        subthemeId?: string;
        isTrigger?: boolean;
        disabled?: boolean;
        className?: string;
        size?: "sm" | "md";
        ref?: Ref<HTMLButtonElement>;
    }
> = ({
    themeId,
    subthemeId,
    isTrigger = false,
    disabled = false,
    className,
    size = "sm",
    ref,
    ...props
}) => {
    const currentTheme = useTheme(themeId);
    const currentSubtheme =
        subthemeId &&
        currentTheme?.subthemes?.find((subtheme) => subtheme.id === subthemeId);

    const { t } = useTranslation(RESOURCE_NAME);

    return (
        <Chip
            className={className}
            size={size}
            interactive={isTrigger}
            disabled={disabled}
            ref={ref}
            {...props}
        >
            <Chip.Icon
                name="tagEmptyCircle"
                size={size === "sm" ? "sm" : "md"}
                color={currentTheme?.color}
            />
            <Chip.Value>
                {currentSubtheme
                    ? currentSubtheme?.name
                    : isTrigger
                      ? t(keys.select_subtheme)
                      : t(keys.no_subtheme)}
            </Chip.Value>
            {isTrigger && <Chip.Icon name="chevronDown" />}
        </Chip>
    );
};
